import { select, call, takeLatest, put } from 'redux-saga/effects';
import { ProgramBookActions } from '../constants';
import { ProgramBookApi, SeanceApi } from 'src/services/end-points';
import { groupProgramBook } from 'src/helpers/programBook';
import {
    PersistProgramBookAction,
    GetProgramBooksAction,
    GetProgramBookAction,
    createFilesProgramBook,
    GetFilesProgramBookAction,
    CreateFilesProgramBookction,
    GetProgramBookAnswersAction,
    PersistProgramBookAnswerAction,
    DeleteFileProgramBookAction,
    getProgramBookEntity,
    PersistProgramBookAnswerOfTargetAction,
    GetProgramBooksSmallAction,
} from '../actions/program-book-actions';
import {
    handleError,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
} from '../../services/api-handlers/api-resolver';
import { SubmissionError } from 'redux-form';
import { StoreState } from '../reducers';
import { PaginationService } from '../../services/api-handlers/pagination';
import sortingService from '../../services/sorting';
import { convertValuesToFormData } from '../../components/redux-form/utils/values-to-form-data';
import { makeFormErrors } from '../../components/redux-form/utils/make-form-errors';
import { goBack, push } from 'connected-react-router';
import Router from '../../navigation/router';
import routes from '../../navigation/routes';
import { groupProgramBookAnswers } from '../../helpers/programBookAnswers';
import history from '../../navigation/history';
import { groupProgramBookAnswerOfTarget } from '../../helpers/programBookAnswerOfTarget';

function* handlePersistProgramBook(action: PersistProgramBookAction) {
    const { payload } = action;
    const {
        data: { id, ...restData },
        files,
        callbacks,
    } = payload;

    let groupedProgramBook: any;
    try {
        groupedProgramBook = groupProgramBook(restData);
    } catch (error) {
        console.error('groupProgramBook error:', error);
        yield call(
            callbacks.reject,
            new SubmissionError({
                _error: error?.message ?? 'Error preparing data for save',
            }),
        );
        return;
    }

    yield resolveApiCall(
        action,
        () =>
            id
                ? ProgramBookApi.updateProgramBook(id, groupedProgramBook)
                : ProgramBookApi.createProgramBook(groupedProgramBook),
        function* (data: ResolverApiSuccess) {
            yield put(createFilesProgramBook(data.payload.id, files.files, callbacks));
            //
            if (!id) {
                yield put(
                    push(
                        Router.generate(routes.PROGRAM_BOOK_EDIT, {
                            id: data.payload.id,
                        }),
                    ),
                );
            } else {
                yield put(getProgramBookEntity(id, '1'));
            }

            yield call(callbacks.resolve);
        },
        function* (result: ResolverApiFailure) {
            yield call(
                callbacks.reject,
                result.error instanceof SubmissionError
                    ? result.error
                    : new SubmissionError({
                          _error: result.error?.message ?? 'Incorrect response',
                          ...makeFormErrors(result.error?.response?.data),
                      }),
            );
            yield handleError(result);
        },
    );
}

function* handlePersistProgramBookAnswers(action: PersistProgramBookAnswerAction) {
    const { payload } = action;
    const {
        data: { id, ...restData },
        callbacks,
    } = payload;

    function getUniqueListBy(items: any, key: string) {
        //return Object.values(arr).map((item) =>[item[key], item].values());

        // Declare a new array
        const newArray = [];

        // Declare an empty object
        const uniqueObject: any = {};

        const answers: any = items['answers'];

        // Loop for the array elements
        for (const i in answers) {
            // Extract the title
            //let objTitle = items[i][key];
            // Use the title as the index
            uniqueObject[answers[i][key]] = answers[i];
        }

        // Loop to push unique object into array
        for (const i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }

        // Display the unique objects
        return { seance: items.seance, answers: newArray };
    }

    const groupedProgramBook: any = getUniqueListBy(groupProgramBookAnswers(restData), 'programTarget');

    yield resolveApiCall(
        action,
        () => ProgramBookApi.updateProgramBookAnswers(groupedProgramBook),
        function* (data: ResolverApiSuccess) {
            if (!id) {
                yield put(goBack());
            }

            yield call(callbacks.resolve);
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result?.error?.code && +result.error.code === 401) {
                    yield call(
                        callbacks.reject,
                        result.error instanceof SubmissionError
                            ? result.error
                            : new SubmissionError({
                                  _error: result.error.message ?? 'Incorrect response',
                                  ...makeFormErrors(result.error.response?.data),
                              }),
                    );
                }
                /*yield call(
                    callbacks.reject,
                    result.error instanceof SubmissionError
                        ? result.error
                        : new SubmissionError({
                              _error: result.error.message ?? 'Incorrect response',
                              ...makeFormErrors(result.error.response?.data),
                          }),
                );*/
            }
            yield handleError(result);
        },
    );
}

function* handlePersistProgramBookAnswerOfTarget(action: PersistProgramBookAnswerOfTargetAction) {
    const { payload } = action;
    const {
        data: { id, ...restData },
        target,
        callbacks,
    } = payload;

    function getUniqueListBy(items: any, key: string) {
        const newArray = [];
        const uniqueObject: any = {};
        const answers: any = items['answers'];
        for (const i in answers) {
            uniqueObject[answers[i][key]] = answers[i];
        }
        for (const i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }
        return { seance: items.seance, answers: newArray };
    }

    if (target !== undefined) {
        const groupedProgramBook: any = getUniqueListBy(
            groupProgramBookAnswerOfTarget(restData, target),
            'programTarget',
        );

        yield resolveApiCall(
            action,
            () => ProgramBookApi.updateProgramBookAnswerOfTarget(groupedProgramBook, target),
            function* (data: ResolverApiSuccess) {
                if (!id) {
                    yield put(goBack());
                }

                yield call(callbacks.resolve);
            },
            function* (result: ResolverApiFailure) {
                if (result.error && result.error.response && result.error.response.status) {
                    if (result?.error?.code && +result.error.code === 401) {
                        yield call(
                            callbacks.reject,
                            result.error instanceof SubmissionError
                                ? result.error
                                : new SubmissionError({
                                      _error: result.error.message ?? 'Incorrect response',
                                      ...makeFormErrors(result.error.response?.data),
                                  }),
                        );
                    }
                }
                yield handleError(result);
            },
        );
    }
}

function* handleProgramBookCreateFiles(action: CreateFilesProgramBookction) {
    const {
        payload: { id, files, callbacks },
    } = action;

    if (!files || !files.length) return;
    for (let i = 0; i < files.length; i++) {
        if (files[i].id || files[i]?.attach) {
            continue;
        }
        const formData = convertValuesToFormData({ programBook: id, attachFile: files[i] }, '');
        yield resolveApiCall(
            action,
            () => ProgramBookApi.createProgramBookFiles(formData),
            function* (data: ResolverApiSuccess) {
                yield call(callbacks.resolve);
            },
            function* (result: ResolverApiFailure) {
                if (result.error && result.error.response && result.error.response.status) {
                    yield call(
                        callbacks.reject,
                        result.error instanceof SubmissionError
                            ? result.error
                            : new SubmissionError({
                                  _error: result.error.message ?? 'Incorrect response',
                                  ...makeFormErrors(result.error.response?.data),
                              }),
                    );
                }
                handleError(result);
            },
        );
    }
}
function* handleFetchProgramBook(action: GetProgramBooksAction) {
    const oldData = yield select((state: StoreState) => state.programBooks.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;
    const filterProps: any = { ...filters };

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        ProgramBookApi.getProgramBooks({
            ...filterProps,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchProgramBookSmall(action: GetProgramBooksSmallAction) {
    const oldData = yield select((state: StoreState) => state.programBooks.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;
    const filterProps: any = { ...filters };

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        ProgramBookApi.getProgramBooksSmall({
            ...filterProps,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchProgramBookAnswers(action: GetProgramBookAnswersAction) {
    const oldData = yield select((state: StoreState) => state.programBookAnswers.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;
    const filterProps: any = { ...filters };

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        ProgramBookApi.getProgramBookAnswers({
            ...filterProps,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
            'axios-retry': {
                retries: 3,
            },
        }),
    );
}

function* handleGetFilesProgramBook(action: GetFilesProgramBookAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => ProgramBookApi.getFilesProgramBook(id));
}

function* handleDeleteProgramBookFile(action: DeleteFileProgramBookAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => ProgramBookApi.deleteFileProgramBook(id),
        function (data) {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handleFetchProgramBookEntity(action: GetProgramBookAction) {
    const {
        payload: { id, isHidden },
    } = action;

    yield resolveApiCall(action, () => ProgramBookApi.getProgramBookEntity(id, isHidden));
}
export default function* () {
    yield takeLatest(ProgramBookActions.PROGRAM_BOOK_PERSIST, handlePersistProgramBook);
    yield takeLatest(ProgramBookActions.PROGRAM_BOOK_FETCH, handleFetchProgramBook);
    yield takeLatest(ProgramBookActions.PROGRAM_BOOK_SMALL_FETCH, handleFetchProgramBookSmall);
    yield takeLatest(ProgramBookActions.PROGRAM_BOOK_FETCH_ENTITY, handleFetchProgramBookEntity);
    yield takeLatest(ProgramBookActions.PROGRAM_BOOK_CREATE_FILES, handleProgramBookCreateFiles);
    yield takeLatest(ProgramBookActions.PROGRAM_BOOK_FETCH_FILES, handleGetFilesProgramBook);
    yield takeLatest(ProgramBookActions.DELETE_FILE_PROGRAM_BOOK, handleDeleteProgramBookFile);
    yield takeLatest(ProgramBookActions.PROGRAM_BOOK_ANSWERS_FETCH, handleFetchProgramBookAnswers);
    yield takeLatest(ProgramBookActions.PROGRAM_BOOK_ANSWERS_PERSIST, handlePersistProgramBookAnswers);
    yield takeLatest(ProgramBookActions.PROGRAM_BOOK_ANSWER_OF_TARGET_PERSIST, handlePersistProgramBookAnswerOfTarget);
}
